import { render, staticRenderFns } from "./OctSectionHeader.vue?vue&type=template&id=13260b39&scoped=true&"
import script from "./OctSectionHeader.vue?vue&type=script&lang=js&"
export * from "./OctSectionHeader.vue?vue&type=script&lang=js&"
import style0 from "./OctSectionHeader.vue?vue&type=style&index=0&id=13260b39&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13260b39",
  null
  
)

export default component.exports